export const CampaignListTableLabelConst = [
	'Broadcast ID',
	'Business Name',
	'Broadcast Name',
	'Template Name',
	'Channel',
	'Status',
	'Number Count',
	'On Progress',
	'Sent',
	'Delivered',
	'Read',
	'Failed',
	'Repeat Count',
	'Start Date',
	'End Date',
	'Action',
];

export const CampaignListTableColumnConst = [
	'id',
	'clientName',
	'name',
	'templateName',
	'platform',
	'statusName',
	'numberCount',
	'queuedCount',
	'sentCount',
	'delivCount',
	'readCount',
	'failedCount',
	'repeatCount',
	'startTime',
	'endTime',
	'action',
];
